import Swal from "sweetalert2";

export const handleRentalStatusUpdate = async (rentalId, status, {fetchData, setUpdatingRentalId, rentals, setIsLoading, setError}) => {
    try {
        setUpdatingRentalId(rentalId);
        
        let cancellationReason = null;
        
        // If status is "cancelled", prompt for cancellation reason
        if (status === "cancelled") {
            const result = await Swal.fire({
                title: "Cancellation Reason",
                input: "textarea",
                inputLabel: "Please provide a reason for cancellation:",
                inputPlaceholder: "Enter cancellation reason...",
                inputValidator: (value) => {
                    if (!value) {
                        return "Cancellation reason is required";
                    }
                },
                showCancelButton: true,
                confirmButtonText: "Cancel Rental",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#dc2626",
                cancelButtonColor: "#6b7280",
            });
            
            if (result.isDismissed) {
                return; // User cancelled the operation
            }
            
            cancellationReason = result.value;
        }
        
        await rentals.updateStatus(rentalId, status, cancellationReason);
        fetchData();
    } catch (error) {
        console.error("Error updating rental status:", error);
        await Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to update rental status. Please try again.",
            confirmButtonColor: "#1e3a8a",
        });
    } finally {
        setUpdatingRentalId(null);
    }
};